<div class="relative">
  <button
    type="button"
    class="relative inline-flex h-8 w-8 cursor-pointer items-center justify-center rounded-md text-text-title hover:bg-calypso-light focus:outline-none focus-visible:ring-2 focus-visible:ring-calypso-border"
    aria-label="Notificaciones"
    [attr.aria-expanded]="open()"
    (click)="toggled.emit()"
  >
    <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6 6 0 10-12 0v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
      />
    </svg>
    @if (unreadCount() > 0) {
      <span
        class="absolute -top-1 -right-1 inline-flex min-w-4 items-center justify-center rounded-full bg-error px-1 text-[10px] font-bold text-white"
      >
        {{ unreadCount() }}
      </span>
    }
  </button>

  @if (open()) {
    <div
      class="fixed inset-x-4 top-14 z-50 overflow-hidden rounded-md border border-border-subtle bg-surface-card shadow-lg md:absolute md:inset-x-auto md:top-full md:right-0 md:mt-1 md:w-80"
    >
      <p class="border-b border-border-subtle px-3 py-2 text-sm font-semibold text-text-title">Notificaciones</p>
      @if (loading()) {
        <p class="px-3 py-4 text-sm text-text-muted">Cargando…</p>
      } @else if (loadError()) {
        <p class="px-3 py-4 text-sm text-text-body">No pudimos cargar tus notificaciones. Intenta de nuevo.</p>
      } @else if (items().length === 0) {
        <p class="px-3 py-4 text-sm text-text-muted">No tienes notificaciones</p>
      } @else {
        <ul class="max-h-80 overflow-y-auto">
          @for (item of items(); track item.id) {
            <li>
              <button
                type="button"
                class="flex w-full cursor-pointer flex-col gap-1 px-3 py-2 text-left hover:bg-calypso-light"
                [class.bg-surface-bg]="!item.leida"
                (click)="itemSelected.emit(item)"
              >
                <span class="text-sm font-medium text-text-title">{{ item.titulo }}</span>
                <span class="text-xs text-text-body">{{ item.texto }}</span>
                <span class="text-xs text-text-muted">{{ relativeTime(item.createdAt) }}</span>
              </button>
            </li>
          }
        </ul>
      }
      @if (showChannelsLink()) {
        <button
          type="button"
          class="block w-full cursor-pointer border-t border-border-subtle px-3 py-2 text-left text-sm text-text-title hover:bg-calypso-light"
          (click)="channelsLinkClicked.emit()"
        >
          Canales y correo a bodegas
        </button>
      }
    </div>
  }
</div>
